module.exports = __webpack_public_path__ + "2022426:23e21cd641c426082ae7/img/hero@1x.ef890d1.png";